function toggleDropdown(item) {
    item.classList.toggle('dropdown_block_opened');
  }

const dropdownBlocks = document.querySelectorAll('.dropdown_block');

dropdownBlocks.forEach((item) => {
  const heading = item.querySelector('h4');
  heading.addEventListener('click', (e) => {
    e.preventDefault();
    toggleDropdown(item);
  })
})